export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/twitch_app.7eada77.svg";